export default __webpack_public_path__ + "static/media/Isis.e65db025.jpg";